import type { ReactElement, ReactNode } from 'react';

import useOrganisationFeatures, {
  type OrganisationFeature,
} from 'app/hooks/useOrganisationFeatures';

interface SidebarPlusTagProps {
  feature: OrganisationFeature;
  /** Shown instead when the page isn't tagged Plus+, e.g. its "New" tag. */
  fallback?: ReactNode;
}

/**
 * Tags a Plus page for organisations whose plan doesn't include its feature. Before the new pricing
 * launches it isn't tagged, and nothing (not even the fallback) shows until the features have loaded.
 */
export default function SidebarPlusTag({
  feature,
  fallback = null,
}: SidebarPlusTagProps): ReactElement | null {
  const { pricingLaunched, hasFeature, isLoading, isError } = useOrganisationFeatures();

  if (isLoading || isError) return null;
  if (!pricingLaunched || hasFeature(feature)) return <>{fallback}</>;

  return (
    <span className="vtwo:flex vtwo:h-4 vtwo:shrink-0 vtwo:items-center vtwo:rounded vtwo:bg-linear-to-r vtwo:from-[#f3e6fe] vtwo:to-[#d9eefe] vtwo:px-1">
      <span className="vtwo:bg-linear-to-r vtwo:from-[#8244ba] vtwo:to-[#206b9f] vtwo:bg-clip-text vtwo:text-[10px] vtwo:font-bold vtwo:leading-none vtwo:text-transparent">
        Plus<span className="vtwo:font-semibold vtwo:italic">+</span>
      </span>
    </span>
  );
}
